import { HQDisplayGroup, DisplayGroupCategory, DisplayGroupStatus } from '../types/hqDisplayGroup';
import { Item } from '../types/item';

// 定义接口响应格式
export interface CategoryResponse {
  traceId: string;
  success: boolean;
  msg: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  flag: string;
  code: string | null;
  message: string | null;
  properties: Record<string, any>;
  data: CategoryNode[];
}

// 定义类目节点接口
export interface CategoryNode {
  label: string;
  value: string;
  parentValue: string | null;
  children: CategoryNode[] | null;
}

// 模拟接口响应数据
export const mockCategoryResponse: CategoryResponse = {
  traceId: "26db8fde4a274efe81ea61b6643739b4",
  success: true,
  msg: null,
  errorCode: null,
  errorMessage: null,
  flag: "success",
  code: null,
  message: null,
  properties: {},
  data: [
    // Electronics
    {
      label: "Electronics",
      value: "1",
      parentValue: null,
      children: [
        {
          label: "Computers & Accessories",
          value: "1-1",
          parentValue: "1",
          children: [
            {
              label: "Laptops",
              value: "1-1-1",
              parentValue: "1-1",
              children: [
                {
                  label: "Gaming Laptops",
                  value: "1-1-1-1",
                  parentValue: "1-1-1",
                  children: [
                    {
                      label: "17-inch Gaming Laptops",
                      value: "1-1-1-1-1",
                      parentValue: "1-1-1-1",
                      children: null
                    },
                    {
                      label: "15-inch Gaming Laptops",
                      value: "1-1-1-1-2",
                      parentValue: "1-1-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Business Laptops",
                  value: "1-1-1-2",
                  parentValue: "1-1-1",
                  children: [
                    {
                      label: "Ultrabooks",
                      value: "1-1-1-2-1",
                      parentValue: "1-1-1-2",
                      children: null
                    },
                    {
                      label: "Standard Business Laptops",
                      value: "1-1-1-2-2",
                      parentValue: "1-1-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Desktop Computers",
              value: "1-1-2",
              parentValue: "1-1",
              children: [
                {
                  label: "Gaming Desktops",
                  value: "1-1-2-1",
                  parentValue: "1-1-2",
                  children: [
                    {
                      label: "High-end Gaming Desktops",
                      value: "1-1-2-1-1",
                      parentValue: "1-1-2-1",
                      children: null
                    },
                    {
                      label: "Entry-level Gaming Desktops",
                      value: "1-1-2-1-2",
                      parentValue: "1-1-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Office Desktops",
                  value: "1-1-2-2",
                  parentValue: "1-1-2",
                  children: [
                    {
                      label: "Commercial Office Desktops",
                      value: "1-1-2-2-1",
                      parentValue: "1-1-2-2",
                      children: null
                    },
                    {
                      label: "Home Office Desktops",
                      value: "1-1-2-2-2",
                      parentValue: "1-1-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          label: "Mobile Phones & Accessories",
          value: "1-2",
          parentValue: "1",
          children: [
            {
              label: "Smartphones",
              value: "1-2-1",
              parentValue: "1-2",
              children: [
                {
                  label: "Android Phones",
                  value: "1-2-1-1",
                  parentValue: "1-2-1",
                  children: [
                    {
                      label: "Premium Android Phones",
                      value: "1-2-1-1-1",
                      parentValue: "1-2-1-1",
                      children: null
                    },
                    {
                      label: "Mid-range Android Phones",
                      value: "1-2-1-1-2",
                      parentValue: "1-2-1-1",
                      children: null
                    },
                    {
                      label: "Entry-level Android Phones",
                      value: "1-2-1-1-3",
                      parentValue: "1-2-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Apple iPhones",
                  value: "1-2-1-2",
                  parentValue: "1-2-1",
                  children: [
                    {
                      label: "iPhone Pro Series",
                      value: "1-2-1-2-1",
                      parentValue: "1-2-1-2",
                      children: null
                    },
                    {
                      label: "iPhone Standard Series",
                      value: "1-2-1-2-2",
                      parentValue: "1-2-1-2",
                      children: null
                    },
                    {
                      label: "iPhone SE Series",
                      value: "1-2-1-2-3",
                      parentValue: "1-2-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Phone Accessories",
              value: "1-2-2",
              parentValue: "1-2",
              children: [
                {
                  label: "Phone Cases",
                  value: "1-2-2-1",
                  parentValue: "1-2-2",
                  children: [
                    {
                      label: "Silicone Phone Cases",
                      value: "1-2-2-1-1",
                      parentValue: "1-2-2-1",
                      children: null
                    },
                    {
                      label: "Leather Phone Cases",
                      value: "1-2-2-1-2",
                      parentValue: "1-2-2-1",
                      children: null
                    },
                    {
                      label: "Metal Phone Cases",
                      value: "1-2-2-1-3",
                      parentValue: "1-2-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Chargers",
                  value: "1-2-2-2",
                  parentValue: "1-2-2",
                  children: [
                    {
                      label: "Fast Chargers",
                      value: "1-2-2-2-1",
                      parentValue: "1-2-2-2",
                      children: null
                    },
                    {
                      label: "Wireless Chargers",
                      value: "1-2-2-2-2",
                      parentValue: "1-2-2-2",
                      children: null
                    },
                    {
                      label: "Car Chargers",
                      value: "1-2-2-2-3",
                      parentValue: "1-2-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    // Food & Beverages
    {
      label: "Food & Beverages",
      value: "2",
      parentValue: null,
      children: [
        {
          label: "Beverages",
          value: "2-1",
          parentValue: "2",
          children: [
            {
              label: "Carbonated Drinks",
              value: "2-1-1",
              parentValue: "2-1",
              children: [
                {
                  label: "Cola Drinks",
                  value: "2-1-1-1",
                  parentValue: "2-1-1",
                  children: [
                    {
                      label: "Coca-Cola",
                      value: "2-1-1-1-1",
                      parentValue: "2-1-1-1",
                      children: null
                    },
                    {
                      label: "Pepsi",
                      value: "2-1-1-1-2",
                      parentValue: "2-1-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Soda Drinks",
                  value: "2-1-1-2",
                  parentValue: "2-1-1",
                  children: [
                    {
                      label: "Sprite",
                      value: "2-1-1-2-1",
                      parentValue: "2-1-1-2",
                      children: null
                    },
                    {
                      label: "Fanta",
                      value: "2-1-1-2-2",
                      parentValue: "2-1-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Juices",
              value: "2-1-2",
              parentValue: "2-1",
              children: [
                {
                  label: "Orange Juice",
                  value: "2-1-2-1",
                  parentValue: "2-1-2",
                  children: [
                    {
                      label: "Fresh Orange Juice",
                      value: "2-1-2-1-1",
                      parentValue: "2-1-2-1",
                      children: null
                    },
                    {
                      label: "Concentrated Orange Juice",
                      value: "2-1-2-1-2",
                      parentValue: "2-1-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Apple Juice",
                  value: "2-1-2-2",
                  parentValue: "2-1-2",
                  children: [
                    {
                      label: "Fresh Apple Juice",
                      value: "2-1-2-2-1",
                      parentValue: "2-1-2-2",
                      children: null
                    },
                    {
                      label: "Concentrated Apple Juice",
                      value: "2-1-2-2-2",
                      parentValue: "2-1-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          label: "Snacks",
          value: "2-2",
          parentValue: "2",
          children: [
            {
              label: "Chips",
              value: "2-2-1",
              parentValue: "2-2",
              children: [
                {
                  label: "Potato Chips",
                  value: "2-2-1-1",
                  parentValue: "2-2-1",
                  children: [
                    {
                      label: "Original Potato Chips",
                      value: "2-2-1-1-1",
                      parentValue: "2-2-1-1",
                      children: null
                    },
                    {
                      label: "Flavored Potato Chips",
                      value: "2-2-1-1-2",
                      parentValue: "2-2-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Corn Chips",
                  value: "2-2-1-2",
                  parentValue: "2-2-1",
                  children: [
                    {
                      label: "Tortilla Chips",
                      value: "2-2-1-2-1",
                      parentValue: "2-2-1-2",
                      children: null
                    },
                    {
                      label: "Nacho Chips",
                      value: "2-2-1-2-2",
                      parentValue: "2-2-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Candy",
              value: "2-2-2",
              parentValue: "2-2",
              children: [
                {
                  label: "Chocolate",
                  value: "2-2-2-1",
                  parentValue: "2-2-2",
                  children: [
                    {
                      label: "Dark Chocolate",
                      value: "2-2-2-1-1",
                      parentValue: "2-2-2-1",
                      children: null
                    },
                    {
                      label: "Milk Chocolate",
                      value: "2-2-2-1-2",
                      parentValue: "2-2-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Gummies",
                  value: "2-2-2-2",
                  parentValue: "2-2-2",
                  children: [
                    {
                      label: "Fruit Gummies",
                      value: "2-2-2-2-1",
                      parentValue: "2-2-2-2",
                      children: null
                    },
                    {
                      label: "Sour Gummies",
                      value: "2-2-2-2-2",
                      parentValue: "2-2-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    // Clothing & Apparel
    {
      label: "Clothing & Apparel",
      value: "3",
      parentValue: null,
      children: [
        {
          label: "Men's Clothing",
          value: "3-1",
          parentValue: "3",
          children: [
            {
              label: "Shirts",
              value: "3-1-1",
              parentValue: "3-1",
              children: [
                {
                  label: "Dress Shirts",
                  value: "3-1-1-1",
                  parentValue: "3-1-1",
                  children: [
                    {
                      label: "Cotton Dress Shirts",
                      value: "3-1-1-1-1",
                      parentValue: "3-1-1-1",
                      children: null
                    },
                    {
                      label: "Linen Dress Shirts",
                      value: "3-1-1-1-2",
                      parentValue: "3-1-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Casual Shirts",
                  value: "3-1-1-2",
                  parentValue: "3-1-1",
                  children: [
                    {
                      label: "Polo Shirts",
                      value: "3-1-1-2-1",
                      parentValue: "3-1-1-2",
                      children: null
                    },
                    {
                      label: "T-Shirts",
                      value: "3-1-1-2-2",
                      parentValue: "3-1-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Pants",
              value: "3-1-2",
              parentValue: "3-1",
              children: [
                {
                  label: "Dress Pants",
                  value: "3-1-2-1",
                  parentValue: "3-1-2",
                  children: [
                    {
                      label: "Wool Dress Pants",
                      value: "3-1-2-1-1",
                      parentValue: "3-1-2-1",
                      children: null
                    },
                    {
                      label: "Cotton Dress Pants",
                      value: "3-1-2-1-2",
                      parentValue: "3-1-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Jeans",
                  value: "3-1-2-2",
                  parentValue: "3-1-2",
                  children: [
                    {
                      label: "Straight Leg Jeans",
                      value: "3-1-2-2-1",
                      parentValue: "3-1-2-2",
                      children: null
                    },
                    {
                      label: "Slim Fit Jeans",
                      value: "3-1-2-2-2",
                      parentValue: "3-1-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          label: "Women's Clothing",
          value: "3-2",
          parentValue: "3",
          children: [
            {
              label: "Dresses",
              value: "3-2-1",
              parentValue: "3-2",
              children: [
                {
                  label: "Casual Dresses",
                  value: "3-2-1-1",
                  parentValue: "3-2-1",
                  children: [
                    {
                      label: "Summer Dresses",
                      value: "3-2-1-1-1",
                      parentValue: "3-2-1-1",
                      children: null
                    },
                    {
                      label: "Sundresses",
                      value: "3-2-1-1-2",
                      parentValue: "3-2-1-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "Formal Dresses",
                  value: "3-2-1-2",
                  parentValue: "3-2-1",
                  children: [
                    {
                      label: "Evening Dresses",
                      value: "3-2-1-2-1",
                      parentValue: "3-2-1-2",
                      children: null
                    },
                    {
                      label: "Cocktail Dresses",
                      value: "3-2-1-2-2",
                      parentValue: "3-2-1-2",
                      children: null
                    }
                  ]
                }
              ]
            },
            {
              label: "Tops",
              value: "3-2-2",
              parentValue: "3-2",
              children: [
                {
                  label: "Blouses",
                  value: "3-2-2-1",
                  parentValue: "3-2-2",
                  children: [
                    {
                      label: "Silk Blouses",
                      value: "3-2-2-1-1",
                      parentValue: "3-2-2-1",
                      children: null
                    },
                    {
                      label: "Cotton Blouses",
                      value: "3-2-2-1-2",
                      parentValue: "3-2-2-1",
                      children: null
                    }
                  ]
                },
                {
                  label: "T-Shirts",
                  value: "3-2-2-2",
                  parentValue: "3-2-2",
                  children: [
                    {
                      label: "Basic T-Shirts",
                      value: "3-2-2-2-1",
                      parentValue: "3-2-2-2",
                      children: null
                    },
                    {
                      label: "Graphic T-Shirts",
                      value: "3-2-2-2-2",
                      parentValue: "3-2-2-2",
                      children: null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

// 从树形结构中提取所有叶子节点作为SubClass
export const extractSubClassesFromTree = (nodes: CategoryNode[]): DisplayGroupCategory[] => {
  const subClasses: DisplayGroupCategory[] = [];
  
  const extractLeafNodes = (node: CategoryNode, path: string[] = [], codes: string[] = []) => {
    const currentPath = [...path, node.label];
    const currentCodes = [...codes, node.value];
    
    if (!node.children) {
      // 这是叶子节点，提取为SubClass
      const pathParts = node.value.split('-');
      const categoryId = parseInt(node.value.replace(/-/g, ''));
      
      // 根据节点层级确定各级编码和名称
      let divisionCode = '';
      let divisionName = '';
      let departmentCode = '';
      let departmentName = '';
      let groupCode = '';
      let groupName = '';
      let classCode = '';
      let className = '';
      let subClassCode = '';
      let subClassName = '';
      
      if (currentPath.length >= 5) {
        divisionCode = currentCodes[0] || '';
        divisionName = currentPath[0] || '';
        departmentCode = currentCodes[1] || '';
        departmentName = currentPath[1] || '';
        groupCode = currentCodes[2] || '';
        groupName = currentPath[2] || '';
        classCode = currentCodes[3] || '';
        className = currentPath[3] || '';
        subClassCode = currentCodes[4] || node.value;
        subClassName = currentPath[4] || node.label;
      } else {
        // 如果层级不足5层，则将当前节点作为最后一级
        const level = currentPath.length - 1;
        if (level >= 0) {
          divisionCode = currentCodes[0] || '';
          divisionName = currentPath[0] || '';
        }
        if (level >= 1) {
          departmentCode = currentCodes[1] || '';
          departmentName = currentPath[1] || '';
        }
        if (level >= 2) {
          groupCode = currentCodes[2] || '';
          groupName = currentPath[2] || '';
        }
        if (level >= 3) {
          classCode = currentCodes[3] || '';
          className = currentPath[3] || '';
        }
        subClassCode = node.value;
        subClassName = node.label;
      }
      
      subClasses.push({
        categoryId,
        divisionCode,
        divisionName,
        groupCode,
        groupName,
        departmentCode,
        departmentName,
        classCode,
        className,
        subClassCode,
        subClassName,
        creatorAccount: 'system',
        creatorName: 'System',
        gmtCreate: Date.now(),
        modifierAccount: 'system',
        modifierName: 'System',
        gmtModified: Date.now(),
        deleted: 0
      });
    } else {
      // 递归处理子节点
      node.children.forEach(child => extractLeafNodes(child, currentPath, currentCodes));
    }
  };
  
  nodes.forEach(node => extractLeafNodes(node));
  
  return subClasses;
};

// 生成SubClass数据
export const mockSubClasses: DisplayGroupCategory[] = extractSubClassesFromTree(mockCategoryResponse.data);

// Mock Items data for white/black lists
export const mockItems: Item[] = [
  {
    id: 1,
    code: 'I001',
    name: 'Coca-Cola',
    ownerCode: 'BEVERAGES',
    category: 'Carbonated Drinks',
    status: 'Active'
  },
  {
    id: 2,
    code: 'I002',
    name: 'Pepsi',
    ownerCode: 'BEVERAGES',
    category: 'Carbonated Drinks',
    status: 'Active'
  },
  {
    id: 3,
    code: 'I003',
    name: 'Sprite',
    ownerCode: 'BEVERAGES',
    category: 'Carbonated Drinks',
    status: 'Active'
  },
  {
    id: 4,
    code: 'I004',
    name: 'Fanta',
    ownerCode: 'BEVERAGES',
    category: 'Carbonated Drinks',
    status: 'Active'
  },
  {
    id: 5,
    code: 'I005',
    name: 'Fresh Orange Juice',
    ownerCode: 'BEVERAGES',
    category: 'Juices',
    status: 'Active'
  },
  {
    id: 6,
    code: 'I006',
    name: 'Potato Chips',
    ownerCode: 'SNACKS',
    category: 'Chips',
    status: 'Active'
  },
  {
    id: 7,
    code: 'I007',
    name: 'Corn Chips',
    ownerCode: 'SNACKS',
    category: 'Chips',
    status: 'Active'
  },
  {
    id: 8,
    code: 'I008',
    name: 'Milk Chocolate',
    ownerCode: 'CANDY',
    category: 'Chocolate',
    status: 'Active'
  },
  {
    id: 9,
    code: 'I009',
    name: 'Cotton Dress Shirts',
    ownerCode: 'CLOTHING',
    category: 'Shirts',
    status: 'Active'
  },
  {
    id: 10,
    code: 'I010',
    name: 'Casual Dresses',
    ownerCode: 'CLOTHING',
    category: 'Dresses',
    status: 'Active'
  },
];

// Mock HQ Display Groups data
export const mockHQDisplayGroups: HQDisplayGroup[] = [
  {
    id: 1,
    code: 'DG001',
    name: 'Beverage Display Group',
    subClassSets: [
      mockSubClasses[0], // Carbonated Drinks
      mockSubClasses[1], // Juices
      mockSubClasses[2], // Tea Drinks
    ],
    mainDivision: 'Beverage Division',
    subClassCount: 3,
    status: 'ENABLE',
    whiteListItems: [mockItems[0], mockItems[1]], // Coca-Cola, Pepsi
    blackListItems: [],
    saleDays: 7,
    gmtCreate: '2025-01-15 10:30:00',
    gmtModified: '2025-01-20 14:45:00',
    remark: 'Main display group for beverage products, including carbonated drinks, juices, and tea drinks.',
  },
  {
    id: 2,
    code: 'DG002',
    name: 'Snack Display Group',
    subClassSets: [
      mockSubClasses[4], // Chips
      mockSubClasses[5], // Cookies
      mockSubClasses[6], // Chocolate
    ],
    mainDivision: 'Food Division',
    subClassCount: 3,
    status: 'ENABLE',
    whiteListItems: [],
    blackListItems: [mockItems[7]], // Milk Chocolate
    saleDays: 14,
    gmtCreate: '2025-01-10 09:15:00',
    gmtModified: '2025-01-18 11:20:00',
    remark: 'Display group for various snack products, primarily for the snack area.',
  },
  {
    id: 3,
    code: 'DG003',
    name: 'Drink Display Group',
    subClassSets: [
      mockSubClasses[12] || mockSubClasses[0], // Beer or fallback
      mockSubClasses[14] || mockSubClasses[1], // Red Wine or fallback
    ],
    mainDivision: 'Drink Division',
    subClassCount: 2,
    status: 'ENABLE',
    whiteListItems: [],
    blackListItems: [],
    saleDays: 30,
    gmtCreate: '2025-01-12 13:45:00',
    gmtModified: '2025-01-19 16:30:00',
    remark: 'Display group for drink products, including beer and red wine.',
  },
  {
    id: 4,
    code: 'DG004',
    name: 'Daily Goods Display Group',
    subClassSets: [
      mockSubClasses[8] || mockSubClasses[0], // Shampoo or fallback
      mockSubClasses[9] || mockSubClasses[1], // Body Wash or fallback
    ],
    mainDivision: 'Daily Goods Division',
    subClassCount: 2,
    status: 'ENABLE',
    whiteListItems: [mockItems[8]], // Cotton Dress Shirts
    blackListItems: [],
    saleDays: 45,
    gmtCreate: '2025-01-08 08:30:00',
    gmtModified: '2025-01-17 10:15:00',
    remark: 'Display group for daily goods, primarily including shampoo and body wash.',
  },
  {
    id: 5,
    code: 'DG005',
    name: 'Cosmetics Display Group',
    subClassSets: [
      mockSubClasses[11] || mockSubClasses[0], // Face Masks or fallback
    ],
    mainDivision: 'Daily Goods Division',
    subClassCount: 1,
    status: 'Pending',
    whiteListItems: [],
    blackListItems: [],
    saleDays: 60,
    gmtCreate: '2025-01-21 09:45:00',
    gmtModified: '2025-01-21 09:45:00',
    remark: 'Display group for cosmetics products, currently under review.',
  },
  {
    id: 6,
    code: 'DG006',
    name: 'High-end Drink Display Group',
    subClassSets: [
      mockSubClasses[13] || mockSubClasses[0], // Whiskey or fallback
      mockSubClasses[15] || mockSubClasses[1], // Brandy or fallback
    ],
    mainDivision: 'Drink Division',
    subClassCount: 2,
    status: 'DISABLE',
    whiteListItems: [],
    blackListItems: [],
    saleDays: 90,
    gmtCreate: '2025-01-05 14:20:00',
    gmtModified: '2025-01-15 16:40:00',
    remark: 'Display group for high-end drink products, currently deactivated.',
  },
];

// Mock divisions for 主要事业部 selection
export const mockDivisions = [
  'Beverage Division',
  'Food Division',
  'Daily Goods Division',
  'Drink Division',
];

// Mock categories for filtering
export const mockCategories = [
  'Carbonated Drinks',
  'Juices',
  'Tea Drinks',
  'Coffee Drinks',
  'Chips',
  'Cookies',
  'Chocolate',
  'Nuts',
  'Shampoo',
  'Body Wash',
  'Toothpaste',
  'Face Masks',
  'Beer',
  'Whiskey',
  'Red Wine',
  'Brandy',
];